define('app/views/templates/helpers/showEditButton',['Handlebars'], function ( Handlebars ){
    function showEditButton(obj, block) {
        console.log('ii-i',obj)
        var categoryToShowMap = {
            Spa: app.customization.spaBooking.packageBooking.packageButtonLocations.indexOf(obj.LocationId) > -1 && app.customization.spaBooking.onetimeBookerLocations.indexOf(obj.LocationId) < 0 && obj.ItemClass != "C",
            Retail: false,
            Hotel : false,
            Ski : false,
            Golf: false,
            PMSPayment:false,
            SPAPayment:false,
            Club:false
        }
        if(Object.keys(categoryToShowMap).indexOf(obj.Category) == -1 || categoryToShowMap[obj.Category]) {
            return block.fn(this);
        }
    }

    Handlebars.registerHelper( 'showEditButton', showEditButton );
    return showEditButton;
});
